import { STATIC_BASE_PATH } from '@web/libs/constants'

export const MISSION_HOME_OG_IMAGE_URL = STATIC_BASE_PATH + '/media/images/og_mission_default.jpg'
export const MISSION_HOME_OG_IMAGE_SQUARE_URL = STATIC_BASE_PATH + '/media/images/og_mission_default_square.jpg'
export const MISSION_HOME_DESCRIPTION = '이번 달 리뷰 쓰고 미션 참여해보세요!'
export const fromMissionQuery = {
  KEY: 'from',
  VALUE: 'mission',
} as const
export const CHRISTMAS_BORDER_URL = `https://myplace-phinf.pstatic.net/20221123_63/1669201358856S7spH_PNG/LEASE.png`

// 즉시 지급 시작 날짜
export const REWARD_INSTANCE_START_DATE = '2023-03'
